export const SET_DATA_CASH = 'SET_DATA_CASH'
export const ADD_DATA_CASH = 'ADD_DATA_CASH'
export const UPDATE_DATA_CASH = 'UPDATE_DATA_CASH'
export const REMOVE_DATA_CASH = 'REMOVE_DATA_CASH'
